import React, { Component, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
  Badge,
  ButtonGroup ,
  
} from "react-bootstrap";
import * as Icon from 'react-bootstrap-icons';
import axios from "axios";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File

// Databale

import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import 'primeicons/primeicons.css';
 
import '../../asset/style.css';
 
import {APIKEY} from "../../Config/Config"
// var editor = useRef();
class Certification extends Component {
  constructor() {
    super();
    this.editor = React.createRef();
    this.state = {
      Blogdata: [],
      ID: "",
      certification_Name: "",
      certification_url: "",
      brief_Summary: "",
      certification_Image: "",
      price: "",
      level: "",
      author_Logo: "",
      author_Name: "",
     
      SeoMetaTitle: "",
      SeoMetaDescription: "",
      SeoMetaTags: "",
      SocialShareImage: "",      
      status:null,
      show: false,
      fullscreen: true,
      Deletemodal:"",
      Statusmodal:"",
      // datatable
      filters1: null,
      globalFilterValue1: '',
      loading1: true,
      balanceFrozen: true
    };
  
    this.onGlobalFilterChange1 = this.onGlobalFilterChange1.bind(this);
    this.BanerImage = this.BanerImage.bind(this);
    this.activityBodyTemplate = this.activityBodyTemplate.bind(this);
    this.BlogStatus = this.BlogStatus.bind(this);
    this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    this.rightToolbarTemplate = this.rightToolbarTemplate.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.onChangeBlog = this.onChangeBlog.bind(this);
  }

  componentDidMount() {
    this.getAll();
    this.initFilters1();
  }

  getAll() {
    axios.get(`${APIKEY}/certification/admin`).then((res) => {
      this.setState({
        Blogdata: res.data,
        loading1: false 
      });
      console.log("data", res.data);
    });
  }
  // Datatable Start
  onGlobalFilterChange1(e) {
    const value = e.target.value;
    let filters1 = { ...this.state.filters1 };
    filters1['global'].value = value;

    this.setState({ filters1, globalFilterValue1: value });
}
initFilters1() {
  this.setState({
      filters1: {
          'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      globalFilterValue1: ''
  });
}

renderHeader1() {
  return (
      <div className="flex justify-content-between">
          {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearFilter1} /> */}
          <span className="p-input-icon-left">
              <i className="pi pi-search" />
              <InputText value={this.state.globalFilterValue1} onChange={this.onGlobalFilterChange1} placeholder="Keyword Search" />
          </span>
      </div>
  )
}

BlogStatus(rowData) {
  return (
      <>
      <div className=''>
      {rowData.isActive ? (
                                <>
                                  <h6>
                                  <Badge bg="success">Active</Badge>
                                  </h6>
                                </>
                              ) : (
                                <><h6>
                                  <Badge bg="danger">InActive</Badge>
                                  </h6>
                                </>
                              )}

      </div>
       
      </>
  );
}
activityBodyTemplate(rowData) {
  return (
      <>
      <div className=''>
      <ButtonGroup aria-label="Basic example">
      <Button variant="primary" size="sm"  data-toggle="tooltip" data-placement="left" title="Tooltip on left" onClick={()=>this.EditClickButton(rowData._id)}><Icon.PencilFill /></Button>{" "}
<Button   variant="info" size="sm"  onClick={()=>this.StatusClickButton(rowData._id,rowData.isActive)} ><Icon.Check2Circle /></Button>{" "}
{/* <Button   variant="success" onClick={()=>this.StatusClickButton(rowData._id)} ><Icon.EyeFill /></Button>{" "} */}
<Button  variant="danger" size="sm" onClick={()=>this.DeleteClickButton(rowData._id)}><Icon.TrashFill /></Button>{" "}
</ButtonGroup>
      </div>
       
      </>
  );
}
exportCSV() {
  this.dt.exportCSV();
}

leftToolbarTemplate() {
  return (
      <React.Fragment>
          {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={this.confirmDeleteSelected} disabled={!this.state.selectedProducts || !this.state.selectedProducts.length} /> */}
         <div>
          <h3>Certification</h3>
         </div>
         
      </React.Fragment>
  )
}

rightToolbarTemplate() {
  return (
      <React.Fragment>
          {/* <FileUpload mode="basic" name="demo[]" auto url="https://primefaces.org/primereact/showcase/upload.php" accept=".csv" chooseLabel="Import" className="mr-2 inline-block" onUpload={this.importCSV} /> */}
          <Button label="Export"  variant="warning" className=" bg-warning me-2 btn text-white"
           onClick={this.exportCSV} 
           >Export</Button>
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={this.handleShow} ><Icon.Plus /> Add Certification </Button>

      </React.Fragment>
  )
}

BanerImage(rowData) {
    return (
      <>
        <div className="">
          {rowData.certification_Image ? (
            <>
              <h6>
                <img className="rounded" src={`${APIKEY}/About_image/${rowData.certification_Image}`} width={100}/>
              </h6>
            </>
          ) : null}
        </div>
      </>
    );
  }
  // Datatable end
  // Edit Click Button Start
  EditClickButton=(id)=>{
    if(id){
      axios.get(`${APIKEY}/certification/${id}`).then((res) => {
        this.setState({        
          ID: res.data._id,
      certification_Name: res.data.certification_Name,
      certification_url: res.data.certification_url,
      brief_Summary: res.data.brief_Summary,
      certification_Image: res.data.certification_Image,
     
      price: res.data.price,
      level: res.data.level,
      author_Logo: res.data.author_Logo,
      author_Name: res.data.author_Name,
    
      SeoMetaTitle: res.data.SeoMetaTitle,
      SeoMetaDescription: res.data.SeoMetaDescription,
      SeoMetaTags: res.data.SeoMetaTags,
     
      SocialShareImage: res.data.SocialShareImage,
      show: true,
        });

        console.log("data", res.data);
      });
    }
  }
  // Edit Click Button End

  // Delete click button start
  DeleteClickButton=(id)=>{
    if(id){
      this.setState({
        ID:id,
        Deletemodal:true
      })
    }
  }
  // Delete click button end

  // Status click button start
  StatusClickButton=(id,status)=>{
    if(id){
      this.setState({
        ID:id,
        status:status,
        Statusmodal:true
      })
    }
  }
  // Delete click button end

  // Onchange
  onChangeBlog = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
    console.log("onchnage",value)
  };
  //
  handleChangecertification_Image = async (e) => {
    const file = e.target.files[0];
    const MIN_FILE_SIZE = 1024 // 1MB
   console.log("tesss",file)
    const fileSizeKiloBytes = file.size / MIN_FILE_SIZE
    if(fileSizeKiloBytes > MIN_FILE_SIZE){
      alert("File size is less than minimum limit");
     return
    } 

      this.setState({
        certification_Image: file,
      });
     
    
  };
  handleChangeauthor_Logo = async (e) => {
    const file = e.target.files[0];
    this.setState({
      author_Logo: file,
    });
  };
  onChangeSocialShareImage = async (e) => {
    const file = e.target.files[0];
    this.setState({
      SocialShareImage: file,
    });
  };


  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleShow = (event) => {
    this.setState({
      show: true,
    });
  };
  ModelClose = (event) => {
    this.setState({
      ID:"",
      certification_Name: "",
      certification_url: "",
     brief_Summary: "",
      certification_Image: "",
     
      price: "",
      level: "",
      author_Logo: "",
      author_Name: "",
   
   
      SeoMetaTitle: "",
      SeoMetaDescription: "",
      SeoMetaTags: "",
   
      SocialShareImage: "",
      show: false,
    });
  };

  DeleteModelClose = (event) => {
    this.setState({
      ID:"",
      Deletemodal: false,
    });
  };
  StatusModelClose = (event) => {
    this.setState({
      ID:"",
      status:'',
      Statusmodal: false,
    });
  };
  // editor events

  getSunEditorInstance = (sunEditor) => {
    this.editor.current = sunEditor;
  };
// Blog Submit 
  BlogSubmit = (event) => {
    event.preventDefault();
    if (this.state.ID) {
      this.EditBlogSubmit(this.state.ID);
    } else {
      this.AddBlogSubmit();
    }
  };

  AddBlogSubmit = (event) => {
    console.log("ttttt",this.state.certification_Image);

    const formData = new FormData();

    formData.append("certification_Name", this.state.certification_Name);
    formData.append("certification_url", this.state.certification_url);
   formData.append("brief_Summary", this.state.brief_Summary);
    formData.append("certification_Image", this.state.certification_Image);
   
    formData.append("price", this.state.price);
    formData.append("level", this.state.level);
    formData.append("author_Logo", this.state.author_Logo);
    formData.append("author_Name", this.state.author_Name);
  
    formData.append("SeoMetaTitle", this.state.SeoMetaTitle);
    formData.append("SeoMetaDescription", this.state.SeoMetaDescription);
    formData.append("SeoMetaTags", this.state.SeoMetaTags);
  
    formData.append("SocialShareImage", this.state.SocialShareImage);
    console.log("formData", this.state.certification_Name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios.post(`${APIKEY}/certification`, formData, config).then((res) => {
        if (res.data) {
          console.log("test ok");
          this.getAll();
          this.ModelClose();
          this.toast.show({ severity: 'success', summary: 'Successful', detail: 'Blog Data', life: 3000 });
        }
    }).catch((e)=>{
         console.log(e)
    })
  };
  EditBlogSubmit = (id) => {
    if(id){
      const formData = new FormData();

      formData.append("certification_Name", this.state.certification_Name);
      formData.append("certification_url", this.state.certification_url);
      formData.append("brief_Summary", this.state.brief_Summary);
      formData.append("certification_Image", this.state.certification_Image);
   
      formData.append("price", this.state.price);
      formData.append("level", this.state.level);
      formData.append("author_Logo", this.state.author_Logo);
      formData.append("author_Name", this.state.author_Name);
   
      formData.append("SeoMetaTitle", this.state.SeoMetaTitle);
      formData.append("SeoMetaDescription", this.state.SeoMetaDescription);
      formData.append("SeoMetaTags", this.state.SeoMetaTags);
    
      formData.append("SocialShareImage", this.state.SocialShareImage);
      console.log("formData", this.state.certification_Name);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios.put(`${APIKEY}/certification/${id}`, formData, config).then(res => {
        if (res.data) {
          console.log("Update okkk");
          this.getAll();
          this.ModelClose();
          this.toast.show({ severity: 'success', summary: 'Update Successful', detail: 'Blog Data', life: 3000 });

        }

      }).catch((e)=>{
        console.log(e)
   })
    }
  };
  // Delete Blog Data
  DeleteBlogData=(event)=>{
    if(this.state.ID){
      axios.delete(`${APIKEY}/certification/delete/${this.state.ID}`).then((res) => {
      
        console.log("data", res.data);
        this.getAll();
        this.setState({
          Deletemodal: false,
        });
        this.toast.show({ severity: 'success', summary: 'Successful', detail: 'Blog Data Delete', life: 3000 });

      });
    }
  }
  // Blog Status Submit
   // Blog Status Submit
   StatusSubmit=(event)=>{
    if(this.state.ID){
      event.preventDefault();
      const formData = new FormData();
      formData.append("isActive", this.state.status);
      console.log(this.state.status,"this.state.status")
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios.put(`${APIKEY}/certification/status/${this.state.ID}`, formData, config).then(res => {
        if (res.data) {
          console.log("Update okkk");
          this.getAll();
          this.StatusModelClose();
          this.toast.show({ severity: 'success', summary: 'Successful', detail: 'Blog Status', life: 3000 });

        }

      }).catch((e)=>{
        console.log(e)
   })
    
    }
    
    }

  
  
  render() {
    const header1 = this.renderHeader1();
   
    return (
      <>
        <div className="container-fluid">
          
          <Toast ref={(el) => this.toast = el} />
          
          {/* Modal */}
          <Modal
            show={this.state.show}
            fullscreen={this.state.fullscreen}
            onHide={this.ModelClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Certification</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Container>
                  <Form onSubmit={this.BlogSubmit}>
                    <Row>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Certification Headline</Form.Label>
                          <Form.Control
                            type="text"
                            name="certification_Name"
                            value={this.state.certification_Name}
                            onChange={this.onChangeBlog}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Certification URL name</Form.Label>
                          <Form.Control
                            type="text"
                            name="certification_url"
                            value={this.state.certification_url}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                  
                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Certification Brief Description</Form.Label>
                          <Form.Control
                          as="textarea" rows={4}
                            type="text"
                            name="brief_Summary"
                            value={this.state.brief_Summary}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Price</Form.Label>
                          <Form.Control
                            type="text"
                            name="price"
                            value={this.state.price}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col> */}
                      {/* <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Level</Form.Label>
                          <Form.Control
                            type="text"
                            name="level"
                            value={this.state.level}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col> */}
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Certification Image</Form.Label>
                          <Form.Control
                            type="file"
                            name=""
                            onChange={this.handleChangecertification_Image}
                            placeholder=""
                          />
                        </Form.Group>
                         
                        {this.state.ID && this.state.certification_Image  ?<>
                         {this.state.certification_Image.size ? <>
                          <img className="rounded" src={URL.createObjectURL(this.state.certification_Image)} width={100} alt="dfgh" />
                          <Button variant="danger" onClick={()=>{this.setState({certification_Image:""})}}><Icon.TrashFill /></Button>
                         </>:<>
                         <img src={`${APIKEY}/Blog_image/${this.state.certification_Image}`} className="rounded" width={100}/>
                        <Button variant="danger" onClick={()=>{this.setState({certification_Image:""})}} ><Icon.TrashFill /></Button></>}
                       
                        </>: null}
                        
                      </Col>
                 
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Author Profile Image</Form.Label>
                          <Form.Control
                            type="file"
                            name=""
                            onChange={this.handleChangeauthor_Logo}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.author_Logo  ?<>
                         {this.state.author_Logo.size ? <>
                          <img className="rounded" src={URL.createObjectURL(this.state.author_Logo)} width={100} alt="dfgh" />
                          <Button variant="danger" onClick={()=>{this.setState({author_Logo:""})}}><Icon.TrashFill /></Button>
                         </>:<>
                         <img src={`${APIKEY}/Blog_image/${this.state.author_Logo}`} className="rounded" width={100}/>
                        <Button variant="danger" onClick={()=>{this.setState({author_Logo:""})}} ><Icon.TrashFill /></Button></>}
                       
                        </>: null}
                        
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Author Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="author_Name"
                            value={this.state.author_Name}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                  
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTitle"
                            value={this.state.SeoMetaTitle}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Description</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaDescription"
                            value={this.state.SeoMetaDescription}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>SeoMeta Tags</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTags"
                            value={this.state.SeoMetaTags}
                            onChange={this.onChangeBlog}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Social Share Image</Form.Label>
                          <Form.Control
                            type="file"
                            name="SocialShareImage"
                            onChange={this.onChangeSocialShareImage}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.SocialShareImage ?<>
                         {this.state.SocialShareImage.size ? <>
                          <img className="rounded" src={URL.createObjectURL(this.state.SocialShareImage)} width={100} alt="dfgh" />
                          <Button variant="danger" onClick={()=>{this.setState({SocialShareImage:""})}}><Icon.TrashFill /></Button>
                         </>:<>
                         <img src={`${APIKEY}/Blog_image/${this.state.SocialShareImage}`} className="rounded" width={100}/>
                        <Button variant="danger" onClick={()=>{this.setState({SocialShareImage:""})}} ><Icon.TrashFill /></Button></>}
                       
                        </>: null}
 
                      </Col>
                 
                    </Row>
                   
                    <Row>
                      <div className="d-flex justify-content-end">
                        <br></br>
                        <Button variant="danger" className="me-2" onClick={this.ModelClose}>
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit" >
                        {this.state.ID ? "Update" :"Submit"}  
                        </Button>
                        
                       
                      </div>
                    </Row>
                  </Form>
                </Container>
              </div>
            </Modal.Body>
          </Modal>
          {/* Modal end */}
          <div>
            {/* Datatable start*/}
          
                    <Toolbar className="mb-4" left={this.leftToolbarTemplate} right={this.rightToolbarTemplate}></Toolbar>

            <DataTable value={this.state.Blogdata} ref={(el) => this.dt = el}  size="small" paginator scrollable scrollHeight="400px" className="p-datatable-customers" showGridlines rows={10}
                        dataKey="id" filters={this.state.filters1} filterDisplay="menu" loading={this.state.loading1} responsiveLayout="scroll"
                        globalFilterFields={['certification_Name', 'certification_url']} header={header1} emptyMessage="No customers found.">
                        <Column field="certification_Name" header="Certification Name" alignFrozen="left" frozen={this.state.balanceFrozen}  style={{ minWidth: '12rem' }} />
                        <Column
                field="BlogShortDescription"
                header="Certification Images"
                body={this.BanerImage}
                style={{ minWidth: "10rem" }}
              />
                        <Column field="certification_url" header="certification url"   style={{ minWidth: '0px ' }} />
                        {/* <Column field="price" header="price"   style={{ minWidth: '0px ' }} /> */}
                        {/* <Column field="level" header="level"   style={{ minWidth: '0px ' }} /> */}
                        <Column field="author_Name" header="author_Name"   style={{ minWidth: '0px ' }} />
                        {/* <Column field="brief_Summary" header="Status" body={this.BlogStatus}  style={{ minWidth: '0px ' }} /> */}
                        
                        <Column field="activity" header="Activity" showFilterMatchModes={false} alignFrozen="right" frozen={this.state.balanceFrozen} style={{ minWidth: '6rem' }} body={this.activityBodyTemplate} />
                       </DataTable>
            {/* Datatable end*/}

            {/* Delete data modal start */}
            <Modal
       show={this.state.Deletemodal}
       onHide={this.DeleteModelClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         Delete 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Do you want delete this data ?</h4>
        
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.DeleteModelClose}>No</Button>
        <Button variant="danger" onClick={this.DeleteBlogData}>Yes</Button>
      </Modal.Footer>
    </Modal>
            {/* Delete data modal end */}
            {/* Status data modal start */}
            <Modal
       show={this.state.Statusmodal}
       onHide={this.StatusModelClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         Status   
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Form onSubmit={this.StatusSubmit}>
                    <Row>
                      <Col md={12}>
                      <Form.Group as={Row} className="mb-3">
          <Form.Label as="legend" column sm={2}>
            Status
          </Form.Label>
          <Col sm={10}>
            <Form.Check
              type="radio"
              label="Active"
              name="status"
              value={true}
              onChange={this.onChangeBlog}
              id="formHorizontalRadios1"
            />
            <Form.Check
              type="radio"
              label="Inactive"
              name="status"
              value={false}
              onChange={this.onChangeBlog}
              id="formHorizontalRadios2"
            />
          
          </Col>
        </Form.Group>
                      </Col>
                    
                    </Row>
                    
                    <Row>
                      <div className="d-flex justify-content-end">
                        <br></br>
                      
                        <Button variant="danger" className="me-2" onClick={this.StatusModelClose}>
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                          Submit
                        </Button>
                      </div>
                    </Row>
                  </Form>
      </Modal.Body>
      
    </Modal>
            {/* Status data modal end */}
          </div>
        </div>
      </>
    );
  }
}
export default Certification;
